import { render } from "./List.vue?vue&type=template&id=0c6d48a7&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=0c6d48a7&lang=less&scoped=true"
import "./List.vue?vue&type=style&index=1&id=0c6d48a7&lang=less"
script.render = render
script.__scopeId = "data-v-0c6d48a7"

export default script